import config from '../config';

// ✅ Get all controller units
export const getAllControllers = async () => {
  const response = await fetch(`${config.apiUrl}/api/controllers`);
  if (!response.ok) throw new Error('Failed to fetch controllers');
  return response.json();
};

// ✅ Get controller unit by MAC address
export const getControllerByMAC = async (mac) => {
  const response = await fetch(`${config.apiUrl}/api/controllers/mac/${mac}`);
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to fetch controller');
  return data;
};
// ✅ scan controller unit by MAC address
export const scanControllerByMAC = async (mac) => {
  const response = await fetch(`${config.apiUrl}/api/controllers/scan-mac/${encodeURIComponent(mac)}`);
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to fetch controller');
  return data;
};

// ✅ Create new controller unit
export const createController = async (controllerData) => {
  const response = await fetch(`${config.apiUrl}/api/controllers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(controllerData),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to create controller');
  return data;
};

// ✅ Update controller unit by ID
export const updateController = async (id, updatedData) => {
  const response = await fetch(`${config.apiUrl}/api/controllers/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedData),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to update controller');
  return data;
};

// ✅ Delete controller unit by ID (soft delete)
export const deleteController = async (id) => {
  const response = await fetch(`${config.apiUrl}/api/controllers/${id}`, {
    method: 'DELETE',
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to delete controller');
  return data;
};
